// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__DE4iT","plus":"styles_plus__NnHNi","key":"styles_key__Shovj"};